export default {
  CLIENT_DETAILS_SUCCESS: '@CLIENTS_CLIENT_DETAILS_SUCCESS',
  CLIENT_DETAILS_LOADING: '@CLIENTS_CLIENT_DETAILS_LOADING',
  CLIENT_DETAILS_ERROR: '@CLIENTS_CLIENT_DETAILS_ERROR',
  CMD_PROFILE_LOADING: '@CLIENTS_CMD_PROFILE_LOADING',
  CMD_PROFILE_SUCCESS: '@CLIENTS_CMD_PROFILE_SUCCESS',
  CMD_PROFILE_ERROR: '@CLIENTS_CMD_PROFILE_ERROR',
  CLEAR_CMD_PROFILE_DATA: '@CLIENTS_CLEAR_CMD_PROFILE_DATA',

  CREATE_ONLINE_ACCOUNT_SUCCESS: '@CLIENTS_CREATE_ONLINE_ACCOUNT_SUCCESS',
  CREATE_ONLINE_ACCOUNT_LOADING: '@CLIENTS_CREATE_ONLINE_ACCOUNT_LOADING',
  CREATE_ONLINE_ACCOUNT_ERROR: '@CLIENTS_CREATE_ONLINE_ACCOUNT_ERROR',

  UPDATE_ONLINE_ACCOUNT_LOADING: '@UPDATE_ONLINE_ACCOUNT_LOADING',
  UPDATE_ONLINE_ACCOUNT_SUCCESS: '@UPDATE_ONLINE_ACCOUNT_SUCCESS',
  UPDATE_ONLINE_ACCOUNT_FAILURE: '@UPDATE_ONLINE_ACCOUNT_FAILURE',

  CLIENTS_LIST_SUCCESS: '@CLIENTS_CLIENTS_LIST_SUCCESS',
  CLIENTS_LIST_LOADING: '@CLIENTS_CLIENTS_LIST_LOADING',
  CLIENTS_LIST_ERROR: '@CLIENTS_CLIENTS_LIST_ERROR',

  CLIENTS_INFINITE_LIST_LOADING: '@CLIENTS_INFINITE_LIST_LOADING',
  CLIENTS_INFINITE_LIST_STATS: '@CLIENTS_INFINITE_LIST_STATS',
  CLIENTS_INFINITE_LIST_SUCCESS: '@CLIENTS_INFINITE_LIST_SUCCESS',
  CLIENTS_INFINITE_LIST_CLEAR: '@CLIENTS_INFINITE_LIST_CLEAR',

  CLIENTS_LIST_RESTORE: '@CLIENTS_CLIENTS_LIST_RESTORE',

  GET_CLIENT_NOTES_SUCCESS: '@CLIENTS_GET_CLIENT_NOTES_SUCCESS',
  GET_CLIENT_NOTES_LOADING: '@CLIENTS_GET_CLIENT_NOTES_LOADING',
  GET_CLIENT_NOTES_ERROR: '@CLIENTS_GET_CLIENT_NOTES_ERROR',

  CREATE_CLIENT_NOTE_LOADING: '@CLIENTS_CREATE_NOTE_LOADING',
  CREATE_CLIENT_NOTE_SUCCESS: '@CLIENTS_CREATE_NOTE_SUCCESS',
  CREATE_CLIENT_NOTE_ERROR: '@CLIENTS_CREATE_NOTE_ERROR',

  DELETE_CLIENT_NOTES_SUCCESS: '@CLIENTS_DELETE_CLIENT_NOTES_SUCCESS',
  DELETE_CLIENT_NOTES_LOADING: '@CLIENTS_DELETE_CLIENT_NOTES_LOADING',
  DELETE_CLIENT_NOTES_ERROR: '@CLIENTS_DELETE_CLIENT_NOTES_ERROR',

  EDIT_CLIENT_NOTE_LOADING: '@CLIENT_EDIT_NOTE_LOADING',
  EDIT_CLIENT_NOTE_SUCCESS: '@CLIENT_EDIT_NOTE_SUCCESS',
  EDIT_CLIENT_NOTE_ERROR: '@CLIENT_EDIT_NOTE_ERROR',

  GET_CLIENT_NOTE_DETAILS_LOADING: '@CLIENT_GET_NOTE_DETAILS_LOADING',
  GET_CLIENT_NOTE_DETAILS_SUCCESS: '@CLIENT_GET_NOTE_DETAILS_SUCCESS',
  GET_CLIENT_NOTE_DETAILS_ERROR: '@CLIENT_GET_NOTE_DETAILS_ERROR',

  CLIENTS_CENTRAL_SEARCH_SUCCESS: '@CLIENTS_CENTRAL_SEARCH_SUCCESS',
  CLIENTS_CENTRAL_SEARCH_LOADING: '@CLIENTS_CENTRAL_SEARCH_LOADING',
  CLIENTS_CENTRAL_SEARCH_ERROR: '@CLIENTS_CENTRAL_SEARCH_ERROR',

  CLIENTS_CENTRAL_SEARCH_CLEAR: '@CLIENTS_CENTRAL_SEARCH_CLEAR',

  CLIENTS_RECENT_LIST_SUCCESS: '@CLIENTS_RECENT_LIST_SUCCESS',
  CLIENTS_RECENT_LIST_LOADING: '@CLIENTS_RECENT_LIST_LOADING',
  CLIENTS_RECENT_LIST_ERROR: '@CLIENTS_RECENT_LIST_ERROR',
  CLIENTS_RECENT_LIST_UPDATE: '@CLIENTS_RECENT_LIST_UPDATE',

  CLIENT_PROFILE_SUCCESS: '@CLIENT_PROFILE_SUCCESS',
  CLIENT_PROFILE_LOADING: '@CLIENT_PROFILE_LOADING',
  CLIENT_PROFILE_ERROR: '@CLIENT_PROFILE_ERROR',

  CLIENT_LOYALTY_SUCCESS: '@CLIENT_LOYALTY_SUCCESS',
  CLIENT_LOYALTY_LOADING: '@CLIENT_LOYALTY_LOADING',
  CLIENT_LOYALTY_ERROR: '@CLIENT_LOYALTY_ERROR',
  CLIENT_LOYALTY_RESET: '@CLIENT_LOYALTY_RESET',

  CLIENTS_SET_SEARCH: '@CLIENTS_SET_SEARCH',
  CLIENTS_SET_FILTER: '@CLIENTS_SET_FILTER',

  CONCIERGE_CART_PRODUCTS_SUCCESS: '@CLIENTS_CONCIERGE_CART_PRODUCTS_SUCCESS',
  CONCIERGE_CART_PRODUCTS_LOADING: '@CLIENTS_CONCIERGE_CART_PRODUCTS_LOADING',
  CONCIERGE_CART_PRODUCTS_ERROR: '@CLIENTS_CONCIERGE_CART_PRODUCTS_ERROR',

  CUSTOMER_CART_PRODUCTS_SUCCESS: '@CLIENTS_CUSTOMER_CART_PRODUCTS_SUCCESS',
  CUSTOMER_CART_PRODUCTS_LOADING: '@CLIENTS_CUSTOMER_CART_PRODUCTS_LOADING',
  CUSTOMER_CART_PRODUCTS_ERROR: '@CLIENTS_CUSTOMER_CART_PRODUCTS_ERROR',

  GET_PRODUCT_BY_SKU_LOADING: '@CLIENTS_GET_PRODUCT_BY_SKU_LOADING',
  GET_PRODUCT_BY_SKU_SUCCESS: '@CLIENTS_GET_PRODUCT_BY_SKU_SUCCESS',
  GET_PRODUCT_BY_SKU_ERROR: '@CLIENTS_GET_PRODUCT_BY_SKU_ERROR',

  CHANGE_SKU: '@CLIENTS_CHANGE_SKU',

  ADD_PRODUCT_TO_CONCIERGE_CART_SUCCESS: '@CLIENTS_ADD_PRODUCT_TO_CONCIERGE_CART_SUCCESS',
  ADD_PRODUCT_TO_CUSTOMER_CART_SUCCESS: '@CLIENTS_ADD_PRODUCT_TO_CUSTOMER_CART_SUCCESS',
  ADD_PRODUCT_TO_CART_ERROR: '@CLIENTS_ADD_PRODUCT_TO_CART_ERROR',

  REMOVE_ITEM_FROM_CONCIERGE_CART_LOADING: '@CLIENTS_REMOVE_ITEM_FROM_CONCIERGE_CART_LOADING',
  REMOVE_ITEM_FROM_CONCIERGE_CART_SUCCESS: '@CLIENTS_REMOVE_ITEM_FROM_CONCIERGE_CART_SUCCESS',
  REMOVE_ITEM_FROM_CONCIERGE_CART_ERROR: '@CLIENTS_REMOVE_ITEM_FROM_CONCIERGE_CART_ERROR',

  REMOVE_ITEM_FROM_CUSTOMER_CART_LOADING: '@CLIENTS_REMOVE_ITEM_FROM_CUSTOMER_CART_LOADING',
  REMOVE_ITEM_FROM_CUSTOMER_CART_SUCCESS: '@CLIENTS_REMOVE_ITEM_FROM_CUSTOMER_CART_SUCCESS',
  REMOVE_ITEM_FROM_CUSTOMER_CART_ERROR: '@CLIENTS_REMOVE_ITEM_FROM_CUSTOMER_CART_ERROR',

  CHANGE_CONCIERGE_CART_ITEM_LOADING: '@CLIENTS_CHANGE_CONCIERGE_CART_ITEM_LOADING',
  CHANGE_CONCIERGE_CART_ITEM_SUCCESS: '@CLIENTS_CHANGE_CONCIERGE_CART_ITEM_SUCCESS',
  CHANGE_CONCIERGE_CART_ITEM_ERROR: '@CLIENTS_CHANGE_CONCIERGE_CART_ITEM_ERROR',

  CHANGE_CUSTOMER_CART_ITEM_LOADING: '@CLIENTS_CHANGE_CUSTOMER_CART_ITEM_LOADING',
  CHANGE_CUSTOMER_CART_ITEM_SUCCESS: '@CLIENTS_CHANGE_CUSTOMER_CART_ITEM_SUCCESS',
  CHANGE_CUSTOMER_CART_ITEM_ERROR: '@CLIENTS_CHANGE_CUSTOMER_CART_ITEM_ERROR',

  ORDER_REVIEW_LOADING: '@CLIENTS_ORDER_REVIEW_LOADING',
  ORDER_REVIEW_SUCCESS: '@CLIENTS_ORDER_REVIEW_SUCCESS',
  ORDER_REVIEW_ERROR: '@CLIENTS_ORDER_REVIEW_ERROR',

  SUBMIT_ORDER_LOADING: '@CLIENTS_SUBMIT_ORDER_LOADING',
  SUBMIT_ORDER_SUCCESS: '@CLIENTS_SUBMIT_ORDER_SUCCESS',
  SUBMIT_ORDER_ERROR: '@CLIENTS_SUBMIT_ORDER_ERROR',

  SET_SHIPMENT_DEFAULT: '@CLIENTS_SET_SHIPMENT_DEFAULT',
  SET_SHIPMENT_SELECTED: '@CLIENTS_SET_SHIPMENT_SELECTED',

  EDIT_SHIPPING_SUCCESS: '@CLIENTS_EDIT_SHIPPING_SUCCESS',
  EDIT_SHIPPING_LOADING: '@CLIENTS_EDIT_SHIPPING_LOADING',
  EDIT_SHIPPING_ERROR: '@CLIENTS_EDIT_SHIPPING_ERROR',

  EDIT_PAYMENTS_SUCCESS: '@CLIENTS_EDIT_PAYMENTS_SUCCESS',
  EDIT_PAYMENTS_LOADING: '@CLIENTS_EDIT_PAYMENTS_LOADING',
  EDIT_PAYMENTS_ERROR: '@CLIENTS_EDIT_PAYMENTS_ERROR',

  ADD_GIFT_CARD_PAYMENT: '@ADD_GIFT_CARD_PAYMENT',
  ADD_GIFT_CARD_PAYMENT_SUCCESS: '@ADD_GIFT_CARD_PAYMENT_SUCCESS',
  ADD_GIFT_CARD_PAYMENT_ERROR: '@ADD_GIFT_CARD_PAYMENT_ERROR',
  UPDATE_GIFT_CARD_PAYMENTS: '@UPDATE_GIFT_CARD_PAYMENTS',

  ADD_LOYALTY_CARD_PAYMENTS: '@CLIENTS_ADD_LOYALTY_CARD_PAYMENTS',
  UPDATE_LOYALTY_CARD_BALANCE: '@CLIENTS_UPDATE_LOYALTY_CARD_BALANCE',

  REMOVE_ORDER_ID: '@CLIENTS_REMOVE_ORDER_ID',
  APPLY_PROMO: '@CLIENTS_APPLY_PROMO',
  REMOVE_PROMO: '@CLIENTS_REMOVE_PROMO',
  RESET_PROMO: '@CLIENTS_RESET_PROMO',

  GET_ORDER_BY_ID_LOADING: '@CLIENTS_GET_ORDER_BY_ID_LOADING',
  GET_ORDER_BY_ID_SUCCESS: '@CLIENTS_GET_ORDER_BY_ID_SUCCESS',
  GET_ORDER_BY_ID_ERROR: '@CLIENTS_GET_ORDER_BY_ID_ERROR',

  GET_PRODUCTS_FOR_ORDER_LOADING: '@CLIENTS_GET_PRODUCTS_FOR_ORDER_LOADING',
  GET_PRODUCTS_FOR_ORDER_SUCCESS: '@CLIENTS_GET_PRODUCTS_FOR_ORDER_SUCCESS',
  GET_PRODUCTS_FOR_ORDER_ERROR: '@CLIENTS_GET_PRODUCTS_FOR_ORDER_ERROR',

  // Client Order History:
  GET_CLIENT_ORDER_HISTORY_LOADING: '@CLIENTS_GET_CLIENT_ORDER_HISTORY_LOADING',
  GET_CLIENT_ORDER_HISTORY_SUCCESS: '@CLIENTS_GET_CLIENT_ORDER_HISTORY_SUCCESS',
  GET_CLIENT_ORDER_HISTORY_ERROR: '@CLIENTS_GET_CLIENT_ORDER_HISTORY_ERROR',

  RESET_CLIENT_ORDER_HISTORY: '@CLIENTS_RESET_CLIENT_ORDER_HISTORY',
  RESET_CLIENT_ORDER_HISTORY_KEEP_FILTERS: '@CLIENTS_RESET_CLIENT_ORDER_HISTORY_KEEP_FILTERS',

  RESTORE_CLIENT_ORDER_HISTORY: '@CLIENTS_RESTORE_CLIENT_ORDER_HISTORY',

  // Associate Order History:
  GET_ASSOCIATE_ORDER_HISTORY_LOADING: '@CLIENTS_GET_ASSOCIATE_ORDER_HISTORY_LOADING',
  GET_ASSOCIATE_ORDER_HISTORY_SUCCESS: '@CLIENTS_GET_ASSOCIATE_ORDER_HISTORY_SUCCESS',
  GET_ASSOCIATE_ORDER_HISTORY_ERROR: '@CLIENTS_GET_ASSOCIATE_ORDER_HISTORY_ERROR',

  RESET_ASSOCIATE_ORDER_HISTORY: '@CLIENTS_RESET_ASSOCIATE_ORDER_HISTORY',
  RESET_ASSOCIATE_ORDER_HISTORY_KEEP_FILTERS: '@CLIENTS_RESET_ASSOCIATE_ORDER_HISTORY_KEEP_FILTERS',

  RESTORE_ASSOCIATE_ORDER_HISTORY: '@CLIENTS_RESTORE_ASSOCIATE_ORDER_HISTORY',

  RESEND_RECEIPT_LOADING: '@CLIENTS_RESEND_RECEIPT_LOADING',
  RESEND_RECEIPT_SUCCESS: '@CLIENTS_RESEND_RECEIPT_SUCCESS',
  RESEND_RECEIPT_ERROR: '@CLIENTS_RESEND_RECEIPT_ERROR',

  CLIENTS_ORDER_CONFIRMATION_LOADING: '@CLIENTS_ORDER_CONFIRMATION_LOADING',
  CLIENTS_ORDER_CONFIRMATION_SUCCESS: '@CLIENTS_ORDER_CONFIRMATION_SUCCESS',
  CLIENTS_ORDER_CONFIRMATION_ERROR: '@CLIENTS_ORDER_CONFIRMATION_ERROR',

  CHANGE_PAYMENTS_LOADING: '@CLIENTS_CHANGE_PAYMENTS_LOADING',
  CHANGE_PAYMENTS_SUCCESS: '@CLIENTS_CHANGE_PAYMENTS_SUCCESS',
  CHANGE_PAYMENTS_ERROR: '@CLIENTS_CHANGE_PAYMENTS_ERROR',

  CHANGE_PAYMENTS_ERROR_RESET: '@CLIENTS_CHANGE_PAYMENTS_ERROR_RESET',

  PRODUCT_PRICE_ADJUSTMENT_LOADING: '@PRODUCT_PRICE_ADJUSTMENT_LOADING',
  PRODUCT_PRICE_ADJUSTMENT_SUCCESS: '@PRODUCT_PRICE_ADJUSTMENT_SUCCESS',
  PRODUCT_PRICE_ADJUSTMENT_ERROR: '@PRODUCT_PRICE_ADJUSTMENT_ERROR',

  GIFT_OPTIONS_LOADING: '@GIFT_OPTIONS_LOADING',
  GIFT_OPTIONS_SUCCESS: '@GIFT_OPTIONS_SUCCESS',
  GIFT_OPTIONS_ERROR: '@GIFT_OPTIONS_ERROR',

  ADD_SHIPPING_LOADING: '@CLIENTS_ADD_SHIPPING_LOADING',
  ADD_SHIPPING_SUCCESS: '@CLIENTS_ADD_SHIPPING_SUCCESS',
  ADD_SHIPPING_ERROR: '@CLIENTS_ADD_SHIPPING_ERROR',

  SAVE_FOR_LATER_PRODUCTS_LOADING: '@CLIENTS_SAVE_FOR_LATER_PRODUCTS_LOADING',
  SAVE_FOR_LATER_PRODUCTS_SUCCESS: '@CLIENTS_SAVE_FOR_LATER_PRODUCTS_SUCCESS',
  SAVE_FOR_LATER_PRODUCTS_ERROR: '@CLIENTS_SAVE_FOR_LATER_PRODUCTS_ERROR',

  ADD_ITEM_TO_SAVE_FOR_LATER_LOADING: '@CLIENTS_ADD_ITEM_TO_SAVE_FOR_LATER_LOADING',
  ADD_ITEM_TO_SAVE_FOR_LATER_SUCCESS: '@CLIENTS_ADD_ITEM_TO_SAVE_FOR_LATER_SUCCESS',
  ADD_ITEM_TO_SAVE_FOR_LATER_ERROR: '@CLIENTS_ADD_ITEM_TO_SAVE_FOR_LATER_ERROR',

  MOVE_BATCH_ITEMS_TO_SAVE_FOR_LATER_SUCCESS: '@CLIENTS_MOVE_BATCH_ITEMS_TO_SAVE_FOR_LATER_SUCCESS',

  MOVE_ONLINE_BAG_PRODUCTS_TO_CONCIERGE_LOADING: '@CLIENTS_MOVE_ONLINE_BAG_PRODUCTS_TO_CONCIERGE_LOADING',
  MOVE_ONLINE_BAG_PRODUCTS_TO_CONCIERGE_SUCCESS: '@CLIENTS_MOVE_ONLINE_BAG_PRODUCTS_TO_CONCIERGE_SUCCESS',
  MOVE_ONLINE_BAG_PRODUCTS_TO_CONCIERGE_ERROR: '@CLIENTS_MOVE_ONLINE_BAG_PRODUCTS_TO_CONCIERGE_ERROR',

  REMOVE_ITEM_FROM_SAVE_FOR_LATER_LOADING: '@CLIENTS_REMOVE_ITEM_FROM_SAVE_FOR_LATER_LOADING',
  REMOVE_ITEM_FROM_SAVE_FOR_LATER_SUCCESS: '@CLIENTS_REMOVE_ITEM_FROM_SAVE_FOR_LATER_SUCCESS',
  REMOVE_ITEM_FROM_SAVE_FOR_LATER_ERROR: '@CLIENTS_REMOVE_ITEM_FROM_SAVE_FOR_LATER_ERROR',

  MOVE_ITEM_FROM_SFL_TO_CONCIERGE_LOADING: '@CLIENTS_MOVE_ITEM_FROM_SFL_TO_CONCIERGE_LOADING',
  MOVE_ITEM_FROM_SFL_TO_CONCIERGE_SUCCESS: '@CLIENTS_MOVE_ITEM_FROM_SFL_TO_CONCIERGE_SUCCESS',
  MOVE_ITEM_FROM_SFL_TO_CONCIERGE_ERROR: '@CLIENTS_MOVE_ITEM_FROM_SFL_TO_CONCIERGE_ERROR',

  CLIENT_ADDRESS_VALIDATION_LOADING: '@CLIENT_ADDRESS_VALIDATION_LOADING',
  CLIENT_ADDRESS_VALIDATION_SUCCESS: '@CLIENT_ADDRESS_VALIDATION_SUCCESS',
  CLIENT_ADDRESS_VALIDATION_ERROR: '@CLIENT_ADDRESS_VALIDATION_ERROR',
  CLIENT_ADDRESS_VALIDATION_RESET: '@CLIENT_ADDRESS_VALIDATION_RESET',

  GET_GROUPS_LOADING: '@CLIENT_GET_GROUPS_LOADING',
  GET_GROUPS_SUCCESS: '@CLIENT_GET_GROUPS_SUCCESS',
  GET_GROUPS_ERROR: '@CLIENT_GET_GROUPS_ERROR',

  GET_CLIENT_GROUPS_LOADING: '@CLIENT_GET_CLIENT_GROUPS_LOADING',
  GET_CLIENT_GROUPS_SUCCESS: '@CLIENT_GET_CLIENT_GROUPS_SUCCESS',
  GET_CLIENT_GROUPS_ERROR: '@CLIENT_GET_CLIENT_GROUPS_ERROR',

  RESET_CLIENT_GROUPS: '@CLIENT_RESET_CLIENT_GROUPS',

  GET_GROUP_CLIENTS_LOADING: '@CLIENT_GET_GROUP_CLIENTS_LOADING',
  GET_GROUP_CLIENTS_SUCCESS: '@CLIENT_GET_GROUP_CLIENTS_SUCCESS',
  GET_GROUP_CLIENTS_ERROR: '@CLIENT_GET_GROUP_CLIENTS_ERROR',

  CREATE_GROUP_LOADING: '@CLIENT_CREATE_GROUP_LOADING',
  CREATE_GROUP_SUCCESS: '@CLIENT_CREATE_GROUP_SUCCESS',
  CREATE_GROUP_ERROR: '@CLIENT_CREATE_GROUP_ERROR',

  STORE_INFORMATION_LOADING: '@CLIENT_STORE_INFORMATION_LOADING',
  STORE_INFORMATION_SUCCESS: '@CLIENT_STORE_INFORMATION_SUCCESS',
  STORE_INFORMATION_ERROR: '@CLIENT_STORE_INFORMATION_ERROR',

  SEARCH_STORE_LOADING: '@CLIENT_SEARCH_STORE_LOADING',
  SEARCH_STORE_SUCCESS: '@CLIENT_SEARCH_STORE_SUCCESS',
  SEARCH_STORE_ERROR: '@CLIENT_SEARCH_STORE_ERROR',

  RESET_STORE_INFORMATION: '@CLIENTS_RESET_STORE_INFORMATION',

  EDIT_GROUP_LOADING: '@CLIENT_EDIT_GROUP_LOADING',
  EDIT_GROUP_SUCCESS: '@CLIENT_EDIT_GROUP_SUCCESS',
  EDIT_GROUP_ERROR: '@CLIENT_EDIT_GROUP_ERROR',

  DELETE_GROUP_LOADING: '@CLIENTS_DELETE_GROUP_LOADING',
  DELETE_GROUP_SUCCESS: '@CLIENTS_DELETE_GROUP_SUCCESS',
  DELETE_GROUP_ERROR: '@CLIENTS_DELETE_GROUP_ERROR',

  EDIT_GROUP_COVER_LOADING: '@CLIENT_EDIT_GROUP_COVER_LOADING',
  EDIT_GROUP_COVER_SUCCESS: '@CLIENT_EDIT_GROUP_COVER_SUCCESS',
  EDIT_GROUP_COVER_ERROR: '@CLIENT_EDIT_GROUP_COVER_ERROR',
  EDIT_GROUP_COVER_MODE_RESET: '@CLIENT_EDIT_GROUP_COVER_MODE_RESET',

  GROUP_DETAILS_LOADING: '@CLIENT_GROUP_DETAILS_LOADING',
  GROUP_DETAILS_SUCCESS: '@CLIENT_GROUP_DETAILS_SUCCESS',
  GROUP_DETAILS_ERROR: '@CLIENT_GROUP_DETAILS_ERROR',
  GROUP_DETAILS_RESET: '@CLIENT_GROUP_DETAILS_RESET',

  ADD_TO_GROUP_LOADING: '@CLIENT_ADD_TO_GROUP_LOADING',
  ADD_TO_GROUP_SUCCESS: '@CLIENT_ADD_TO_GROUP_SUCCESS',
  ADD_TO_GROUP_ERROR: '@CLIENT_ADD_TO_GROUP_ERROR',

  ADD_GROUP_TO_PROFILE: '@CLIENT_ADD_GROUP_TO_PROFILE',

  DELETE_FROM_GROUP_LOADING: '@CLIENT_DELETE_FROM_GROUP_LOADING',
  DELETE_FROM_GROUP_SUCCESS: '@CLIENT_DELETE_FROM_GROUP_SUCCESS',
  DELETE_FROM_GROUP_ERROR: '@CLIENT_DELETE_FROM_GROUP_ERROR',

  GROUPS_SORT_BY: '@CLIENTS_GROUPS_SORT_BY',
  NOTES_FILTER_BY: '@CLIENTS_NOTES_FILTER_BY',

  GLOBAL_SEARCH_ADD_TO_RECENT: '@GLOBAL_SEARCH_ADD_TO_RECENT',
  GLOBAL_SEARCH_CLEAR_RECENT: '@GLOBAL_SEARCH_CLEAR_RECENT',

  GET_BARCODE_SALT_NUMBER_LOADING: '@CLIENT_GET_BARCODE_SALT_NUMBER_LOADING',
  GET_BARCODE_SALT_NUMBER_SUCCESS: '@CLIENT_GET_BARCODE_SALT_NUMBER_SUCCESS',
  GET_BARCODE_SALT_NUMBER_ERROR: '@CLIENT_GET_BARCODE_SALT_NUMBER_ERROR',

  REASON_TO_CONTACT_LOADING: '@CLIENTS_REASON_TO_CONTACT_LOADING',
  REASON_TO_CONTACT_ERROR: '@CLIENTS_REASON_TO_CONTACT_ERROR',
  REASON_TO_CONTACT_SUCCESS: '@CLIENTS_REASON_TO_CONTACT_SUCCESS',
  REASON_TO_CONTACT_RESTORE: '@CLIENTS_REASON_TO_CONTACT_RESTORE',

  REASON_TO_CONTACT_SINGLE_SUCCESS: '@CLIENTS_REASON_TO_CONTACT_SINGLE_SUCCESS',

  REASON_TO_CONTACT_SET_COMPLETED_SUCCESS: '@CLIENTS_REASON_TO_CONTACT_SET_COMPLETED_SUCCESS',

  RESET_ORDER_DETAILS: '@CLIENTS_RESET_ORDER_DETAILS',

  ADD_NEW_REPCIPIENT: '@CLIENTELING_ADD_NEW_REPCIPIENT',

  ORDER_REVIEW_STORE_PICKUP_SUCCESS: '@CLIENTS_ORDER_REVIEW_STORE_PICKUP_SUCCESS',
  SET_STORE_PICKUP_METHOD: '@CLIENTS_SET_STORE_PICKUP_METHOD',

  GET_CLIENT_BADGES_SUCCESS: '@CLIENT_GET_BADGES_SUCCESS',

  CLIENT_CONNECTS_LOADING: '@CLIENT_GET_BADGES_LOADING',
  SET_CLIENT_CONNECTS: '@CLIENT_GET_CONNECTS_SUCCESS',

  CLIENTS_FILTER_FACETS_LOADING: '@CLIENTS_FILTER_FACETS_LOADING',
  CLIENTS_FILTER_FACETS_SUCCESS: '@CLIENTS_FILTER_FACETS_SUCCESS',
  CLIENTS_FILTER_FACETS_ERROR: '@CLIENTS_FILTER_FACETS_ERROR',

  GET_CLIENT_REMINDERS_LOADING: '@CLIENT_GET_CLIENT_REMINDERS_LOADING',
  GET_CLIENT_REMINDERS_SUCCESS: '@CLIENT_GET_CLIENT_REMINDERS_SUCCESS',
  GET_CLIENT_REMINDERS_ERROR: '@CLIENT_GET_CLIENT_REMINDERS_ERROR',

  GET_CLIENT_REMINDER_LOADING: '@CLIENT_GET_CLIENT_REMINDER_LOADING',
  GET_CLIENT_REMINDER_SUCCESS: '@CLIENT_GET_CLIENT_REMINDER_SUCCESS',
  GET_CLIENT_REMINDER_ERROR: '@CLIENT_GET_CLIENT_REMINDER_ERROR',

  CREATE_CLIENT_REMINDER_LOADING: '@CLIENT_CREATE_CLIENT_REMINDER_LOADING',
  CREATE_CLIENT_REMINDER_SUCCESS: '@CLIENT_CREATE_CLIENT_REMINDER_SUCCESS',
  CREATE_CLIENT_REMINDER_ERROR: '@CLIENT_CREATE_CLIENT_REMINDER_ERROR',

  UPDATE_CLIENT_REMINDER_LOADING: '@CLIENT_UPDATE_CLIENT_REMINDER_LOADING',
  UPDATE_CLIENT_REMINDER_SUCCESS: '@CLIENT_UPDATE_CLIENT_REMINDER_SUCCESS',
  UPDATE_CLIENT_REMINDER_ERROR: '@CLIENT_UPDATE_CLIENT_REMINDER_ERROR',

  DELETE_CLIENT_REMINDER_LOADING: '@CLIENT_DELETE_CLIENT_REMINDER_LOADING',
  DELETE_CLIENT_REMINDER_SUCCESS: '@CLIENT_DELETE_CLIENT_REMINDER_SUCCESS',
  DELETE_CLIENT_REMINDER_ERROR: '@CLIENT_DELETE_CLIENT_REMINDER_ERROR',
};
